// extracted by mini-css-extract-plugin
export var heatIcon__dark = "card-job-heat-icons-module--heat-icon__dark--f4cdf";
export var heatIcon__grey = "card-job-heat-icons-module--heat-icon__grey--5c6c4";
export var root = "card-job-heat-icons-module--root--527e8";